export class TokenKeys {
  public static readonly SysproConn = "syspro.sass.SysproConn";
  public static readonly TenantConn = "syspro.sass.TenantConn";
  public static  readonly userId: string="userId";
  public static LogoFileName: string="LogoFileName";
  static LogoUrl: string="logoUrl";
  static TenantMenuList: string='tenantMenuList';
  static UserFullName: string='full_name';
  static EmailAddress: string='email_address';
  static BuyerCode: string='buyerCode';
  static BuyerName: string='buyerName';
  static PurchaseOrderId: string='syspro.sass.po-id';
  static TokenKey: string='sypro.saas.tokenKey';
  static TenantDataEnc: string="syspro.saas.tenantEnc";
  static TenantDataUserEnc: string="syspro.saas.tenantUserEnc";
  static TenantID: string=TokenKeys.SysproConn+".tenantID";
  static TenantActiveID: string=TokenKeys.SysproConn+".tenantActiveID";
  static SupplierObject: string="spro.supp_object";
  static UserClaims: string="syspro.saas.claims";
  static SupportUserClaims: string="syspro.saas.support_claims";
  static UserFileName: string='saas.app_file_name';
  static DefaultUserImage: any="./assets/media/avatars/blank.png";
  static notifications: any='saas.internal.notifications';
  static userImage: any='saas.internal.image';
  static rememberedEmail: string='sass.email_rememberedEmail';
  static lastAccessedRoute: string='sass.last_accessed_route';
    static GrnBranch: string="sass.last_grn_branch";
    static tenatSettings: string='saas.tenant_menu_settings';
    static Tenant: string='sass.tenant_tenant';
    static TenantName: string='saas.tenant_name';
    static lastPoStatus: string='saas_po_status';
  static GlobalTenant: string='saas_global_tenant';
    static TenantSimpleEnc='sass_local_tenant_enc';
    static TenantSimpleSupportUrl='sass_local_tenant_support_url';
    static User: string='saas-local-user';
    static GrnItem: string='saas.local.grn_item';
    static supplier: string='saas.supplier_details';
    static SupplierOnboardingRequest: string = 'saas.supplier.onboarding.request';
    static SupplierOnboardingRequestUpdate: string = 'saas.supplier.onboarding.request.update';
    static SupportServiceUrl: string = 'saas.support_service_url';
}
